import { Link, LoadingSkeleton, PageHeader, formatCurrency } from "shared-components";

import type { JSX } from "react";

interface Props {
  printName?: string;
  name?: string;
  store?: {
    id: string;
    name: string;
  };
  price?: number;
  cardPaymentSettings?: {
    installments: number;
    value: number;
  };
  loading?: boolean;
  storefront?: boolean;
}

export const ProductItemInfo = ({
  printName,
  name,
  store,
  price,
  cardPaymentSettings,
  loading,
  storefront = false,
}: Props): JSX.Element => {
  return (
    <div className="w-full">
      {loading ? (
        <div className="flex h-10 w-full flex-col gap-0.5 lg:gap-1">
          <LoadingSkeleton className="grow" />
          <LoadingSkeleton className="max-w-[65%] grow" />
        </div>
      ) : (
        <div>
          <PageHeader title={printName || name || ""} />
          {printName && <p className="mt-1 text-lg font-normal leading-[1.6875rem]">{name || ""}</p>}
        </div>
      )}

      {loading ? (
        <LoadingSkeleton kind="paragraph" className="brand-accent mt-2 max-w-[8.75rem]" />
      ) : (
        !storefront &&
        store && (
          <p className="mt-2">
            Visite a loja <Link href={`/lojas/${store.id}`} text={store.name} className="underline" />
          </p>
        )
      )}

      <p className="mt-2 font-bold">Preço unitário:</p>

      {loading ? (
        <LoadingSkeleton className="mt-2 h-[3.125rem] max-w-[6.5rem]" />
      ) : (
        <p className="mt-2 text-[2.5rem] font-bold leading-[3.125rem]">{price ? formatCurrency(price) : "R$"}</p>
      )}

      {loading ? (
        <LoadingSkeleton kind="paragraph" className="mt-2 h-3 max-w-[13rem]" />
      ) : (
        cardPaymentSettings && (
          <p className="mt-2">
            <span className="max-lg:hidden">ou em até</span> <b>{cardPaymentSettings.installments}x</b> de{" "}
            <b>{formatCurrency(cardPaymentSettings.value)}</b> sem juros no cartão
          </p>
        )
      )}
    </div>
  );
};
